module.exports = __webpack_public_path__ + "static/media/inventory.81419ac3.png";